import React, { ReactNode, Suspense, lazy } from 'react';
import RootEditProviderNoop from './RootEditProvider.noop';
import { useUserCurrent } from '@/components/provider/UserCurrentProvider';

const RootEditProviderReal = lazy(
    () =>
        import(/* webpackChunkName: "edit-main" */ './RootEditProvider.__real'),
);

export default function RootEditProvider({
    children,
}: {
    children: ReactNode;
}) {
    const { userCurrent } = useUserCurrent();

    if (!userCurrent?.isEditMode) {
        return <RootEditProviderNoop>{children}</RootEditProviderNoop>;
    }

    return (
        <Suspense fallback={null}>
            <RootEditProviderReal>{children}</RootEditProviderReal>
        </Suspense>
    );
}
